import { Card, CardBody, Container, Row, Col } from 'reactstrap';
import { Suspense, useContext, useEffect, useReducer, useRef } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import CommonHeader from '../../../components/Headers/CommonHeader';
import { useLocation } from 'react-router-dom';
import DocumentsFoldersForm from '../Documents/DocumentsFoldersForm';
import DocumentsForm from '../Documents/DocumentsForm';
import { DragDropFiles } from './DragDropFiles';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { DocumentsStateManager, initialDocumentsState } from './DocumentsStateManager';
import { DocumentsFolderListHeader } from './DocumentsFolderListHeader';
import { DragDropFolders } from './DragDropFolders';
import FullScreenSpinner from '../../../components/Core/FullScreenSpinner';

const DocumentsFoldersList = () => {
  const { isMobile } = useCheckMobileScreen();
  const { token, user, currentSchool } = useContext(AuthContext);
  const urlLocation = useLocation()['pathname'];
  const { hash } = useLocation();

  const stateManager = useRef<DocumentsStateManager | null>(null);
  if (!stateManager.current) {
    stateManager.current = new DocumentsStateManager();
  }

  const documentsState = stateManager.current;
  const [state, dispatch] = useReducer(documentsState.reducer, initialDocumentsState);

  documentsState.setReducer(state, dispatch);
  documentsState.setHash(hash);
  documentsState.setLocation(urlLocation);
  documentsState.setUser(user);
  documentsState.setSchool(currentSchool);
  documentsState.setToken(token);

  const hashFolderId = documentsState.state?.hash?.replace('#', '');

  useEffect(() => {
    const doEffect = async () => {
      documentsState.setLoading(true);
      const ModuleName = urlLocation === '/curriculum' ? 'Curriculum' : 'Resources';
      documentsState.setModuleTitle(ModuleName);
      await documentsState.loadFoldersAndDocuments(documentsState.state.filteredOptions, ModuleName, hashFolderId);
      await documentsState.refreshLocalFolder(hash);
      documentsState.setLoading(false);
    };
    doEffect().then();
  }, [documentsState.state.location, documentsState.state.shouldRefresh, documentsState.state.school, hashFolderId]);

  useEffect(() => {
    if (documentsState.state.user?.groupPermission?.name && documentsState.state.title) {
      documentsState.loadGroupPermissions(documentsState.state.title);
    }
  }, [documentsState.state.user?.groupPermission?.name, documentsState.state.title]);

  const changeSchoolReload = () => {
    window.open(`${documentsState.state.location}`, '_self');
  };

  useEffect(() => {
    if (documentsState.state.location == '/curriculum') {
      documentsState.setTitle('Curriculum');
    } else if (documentsState.state.location == '/resource') {
      documentsState.setTitle('Resources');
    }
  }, [documentsState.state.location]);

  useEffect(() => {
    if (Number(hashFolderId) > 0) {
      changeSchoolReload();
    }
  }, [currentSchool]);

  useEffect(() => {
    documentsState.setLoading(false);
  }, [documentsState.state.documentsCards, documentsState.state.foldersCards]);

  return (
    <>
      <FullScreenSpinner showSpinner={documentsState.state.isLoading}></FullScreenSpinner>
      <>
        <CommonHeader />
        {!documentsState.state.isLoading && (
          <Suspense fallback={<></>}>
            <Container
              className="mt--8"
              fluid
              style={isMobile ? { minHeight: 600 } : {}}
              onLoad={() => {
                documentsState.setLoading(false);
              }}
            >
              <Row>
                <Col className="order-xl-2" xl="12">
                  <Card className="bg-secondary shadow">
                    <DocumentsFolderListHeader documentsState={documentsState} />
                    <CardBody>
                      <DragDropFolders documentsState={documentsState} />
                      {hashFolderId && <DragDropFiles documentsState={documentsState} />}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Suspense>
        )}
        {documentsState.state.showFoldersForm && <DocumentsFoldersForm documentsState={documentsState} />}
        {documentsState.state.showDocumentsForm && <DocumentsForm documentsState={documentsState} />}
      </>
    </>
  );
};

export default DocumentsFoldersList;
